import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "h-full item-center justify-center" }
const _hoisted_3 = { class: "form-modal-container" }
const _hoisted_4 = { class: "modal-header mbottom-10px" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row w-full mtop-15 mbottom-15 pright-20" }
const _hoisted_7 = { class: "col-0-8 colend mright-04" }
const _hoisted_8 = { class: "main-m font-m" }

import { ref, watch } from "vue";
import InputText from 'primevue/inputtext';
import { toastError } from "@/utils/toast-utils";
import { useI18n } from "vue-i18n";
import { useToast } from "primevue";


export default /*@__PURE__*/_defineComponent({
  __name: 'esNameForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    label: {},
    name: {},
    selectedDayModelId: {},
    selectedInstituteId: {},
    updateMethod: { type: Function }
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const toast = useToast();

const emit = __emit;

const nameForm = ref<string>(props.name);

/**
 * Closes the modal with confirmation data.
 * @param isConfirmed - Whether the modal action was confirmed.
 */
const closeModal = async (isConfirmed: boolean) => {
  if (isConfirmed) {

    if (nameForm.value) {
      try {
        await props.updateMethod(nameForm.value);
      } catch (e) {
        throw t('error.DEFAULT');
      }
      
    } else {
      toastError(toast, {
            summary: t('common.toast.error'),
            detail: t('error.MANDATORY_DATA_MISSING')
        });  
        
        // Throw error to set at false the var __alreadyClicked in v-one-click directive
        throw t('error.MANDATORY_DATA_MISSING');
    }
  } else if (!isConfirmed) {
    nameForm.value = props.name
    emit("modal-close");
  }
};

watch(
  () => props.name,
  () => {
    if (props.name) {
        nameForm.value = props.name;
    }
  },
  { deep: true }
);



return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.label), 1),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(_unref(InputText), {
                  type: "text",
                  size: "small",
                  modelValue: nameForm.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameForm).value = $event)),
                  class: "w-full"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", null, [
              _renderSlot(_ctx.$slots, "footer", {}, () => [
                _createVNode(_component_es_modal_footer, {
                  onModalCancel: closeModal,
                  confirmModalMethod: async () => await closeModal(true)
                }, null, 8, ["confirmModalMethod"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})